import axios from 'axios';

const api = process.env.VUE_APP_API_URL;
export default {
  /* ********** news ************** */
  async getPublishedNews() {
    const response = await axios.get(`${api}/news/published-news`);
    return response.data;
  },

  async getTopPublishedNews() {
    const response = await axios.get(`${api}/news/published-top-news`);
    return response.data;
  },

  /* **************** announcements ************** */
  async getVisibleAnnouncements() {
    const response = await axios.get(
      `${api}/announcement/visible-announcements`,
    );
    return response.data;
  },

  /* ***************** coaches  ************** */
  async getActiveCoaches() {
    const response = await axios.get(`${api}/coach/active-coaches`);
    return response.data;
  },

  /* ***************** sections  ************** */
  async getActiveSections() {
    const response = await axios.get(`${api}/section/active-sections`);
    return response.data;
  },
};
